/* Swiss Notes — preserve Product -> Cart -> Checkout browser-back sequence. Navigation only. */
(()=>{
  if(window.SNCartBackProductV2)return;
  window.SNCartBackProductV2=true;
  const PRODUCT_KEY='snCartOriginProduct';
  const CART_ARMED='snCartHistoryArmed';
  const CHECKOUT_KEY='snFastCheckoutStarted';
  const isProduct=()=>location.pathname.includes('/products/');
  const isCart=()=>location.pathname==='/cart';
  const get=(k)=>{try{return sessionStorage.getItem(k)||''}catch(e){return''}};
  const set=(k,v)=>{try{sessionStorage.setItem(k,v)}catch(e){}};
  const rememberProduct=()=>{if(isProduct())set(PRODUCT_KEY,location.pathname+location.search+location.hash)};

  if(isProduct()){
    rememberProduct();
    document.addEventListener('submit',e=>{if(e.target.closest('product-form form,form[action*="/cart/add"]'))rememberProduct()},true);
    document.documentElement.addEventListener('cart:change',rememberProduct);
  }

  if(isCart()){
    const origin=get(PRODUCT_KEY);
    if(origin.startsWith('/products/')&&get(CART_ARMED)!==location.href){
      try{
        /* Rebuild only the missing immediate history entry: ... -> product -> cart. */
        history.replaceState({snSyntheticProduct:true},'',origin);
        history.pushState({snRealCart:true},'',location.pathname+location.search+location.hash);
        set(CART_ARMED,location.href);
      }catch(e){}
    }
    document.addEventListener('click',e=>{
      const el=e.target.closest('a,button,input,[role="button"],.shiprocket-headless');
      if(!el)return;
      const text=((el.textContent||el.value||'')+' '+(el.className||'')+' '+(el.getAttribute?.('href')||'')).toLowerCase();
      if(/checkout|buy now|shiprocket|fastrr|fast rr|proceed/.test(text))set(CHECKOUT_KEY,'1');
    },true);
    addEventListener('popstate',e=>{
      if(e.state&&e.state.snSyntheticProduct){const origin=get(PRODUCT_KEY);if(origin.startsWith('/products/'))location.replace(origin)}
    });
  }

  /* Some external/Fast checkout flows return to storefront root instead of restoring Cart.
     Restore Cart once, so subsequent Back continues to the originating product. */
  if(location.pathname==='/'&&get(CHECKOUT_KEY)==='1'&&get(PRODUCT_KEY).startsWith('/products/')){
    set(CHECKOUT_KEY,'');
    location.replace('/cart');
  }
})();
